function ArrowUp() {

    return(
        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
            <path
                d="M6 9l6 6 6-6"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )

}

export default ArrowUp;